import React from 'react'
import ContentWrapper from '../shared/content-wrapper'
import HeadingGamma from '../headings/heading-gamma'
import SignFormWrapper from '../shared/sign-form'
import RegisterForm from '../../services/session/register-form'
import { t } from '../../core/i18n'

const title = t('app:register.title')

const Register = props => (
  <ContentWrapper>
    <SignFormWrapper>
      <HeadingGamma>{title}</HeadingGamma>
      <RegisterForm />
    </SignFormWrapper>
  </ContentWrapper>
)

export default Register



// WEBPACK FOOTER //
// ./src/ui/views/register.js